import React from 'react';
import FooterImg from '../../../assets/img/VACClogo_Corporate.png'
import "./footer.css";
import { getYear } from '../../utils/Helpers';

const PRIVACY_POLICY_URL = 'https://safebuy.com.au/read-the-polices-of-prepurchase-vehicle-services/';
const TERMS_AND_CONDITIONS_URL = 'https://safebuy.com.au/read-the-terms-conditions-of-prepurchase-vehicle-services/';
const BOOKING_REFUND_POLICY_URL = 'https://safebuy.com.au/booking-refund-and-cancellation-policy/';

const PageFooter = () => (
	<div className="FooterContainer">
		<div className="container">
			<div className="d-flex justify-content-between">
				<span>
					<a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">Privacy Policy</a> | 
					<a className='footer-terms-conditions' href={TERMS_AND_CONDITIONS_URL} target="_blank" rel="noopener noreferrer">Terms and Conditions</a> | 
					<a href={BOOKING_REFUND_POLICY_URL} target="_blank" rel="noopener noreferrer">Booking & Refund Policy</a>
				</span>
				<span className='FooterImage'><img src={FooterImg} alt="SafeBuy logo" /></span>
				<span>Copyright ©{getYear()} SafeBuy ABN: 17510261621. All Rights Reserved</span>
			</div>
		</div>
	</div>
);

export default PageFooter;